export default (str) => !!str.match(/^[a-f\d]{24}$/i)
